import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Excel vs logiciel de trésorerie : lequel choisir en 2025 ? | Trezoone',
    description: 'Comparatif honnête entre Excel et un logiciel de trésorerie dédié. Avantages, limites, coûts réels — pour choisir en connaissance de cause.',
    canonical: '/excel-vs-logiciel-tresorerie',
    keywords: 'excel vs logiciel trésorerie, comparatif logiciel trésorerie, excel trésorerie limites, remplacer excel trésorerie',
  },
  hero: {
    tag: 'Excel vs logiciel trésorerie',
    title: 'Excel ou logiciel dédié ? La bonne réponse dépend de votre situation.',
    subtitle: 'Comparatif objectif pour vous aider à choisir — sans langue de bois.',
    ctaLabel: 'Voir Trezoone en action',
  },
  pilierLink: { label: 'Guide : logiciel de trésorerie', href: '/logiciel-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Excel : vraiment bien quand…',
      content: 'Excel est un excellent outil dans des conditions précises :',
      items: [
        'Votre structure est très simple (1 compte, peu de flux, 1 personne gère tout)',
        'Vous avez des compétences Excel solides et du temps pour le maintenir',
        'Votre budget est réellement à zéro et vous acceptez le risque d\'erreur',
        'Vous n\'avez pas besoin d\'alertes ou de prévisions automatisées',
      ],
    },
    {
      type: 'example',
      title: 'Les vraies limites d\'Excel en trésorerie',
      content: 'Ce que Excel ne fait pas — et que vous découvrirez souvent au mauvais moment :',
      items: [
        'Pas de connexion bancaire → vous ressaisissez tout manuellement (30 à 120 min/mois)',
        'Pas d\'alertes → vous découvrez le problème en regardant le fichier (si vous l\'ouvrez)',
        'Erreurs silencieuses → une formule cassée fausse tout sans que vous le sachiez',
        'Partage difficile → versions multiples, risque de confusion, pas de droits différenciés',
        'Pas de scénarios → modifier une hypothèse casse souvent d\'autres cellules',
        'Pas de rapport automatique → vous passez du temps à formater pour chaque réunion CA',
      ],
    },
    {
      type: 'midcta',
      title: 'Plus de 2 heures par mois sur Excel ? C\'est le signal pour passer à un outil dédié',
      content: 'Trezoone se prend en main en moins d\'une heure. Connexion bancaire, alertes automatiques, scénarios : tout ce qu\'Excel ne peut pas faire.',
    },
    {
      type: 'checklist',
      title: 'Quand passer à un logiciel dédié ?',
      items: [
        'Vous gérez plus de 2 comptes bancaires différents',
        'Vous avez plusieurs sources de financement (subventions, crédits, clients multiples)',
        'Vous passez plus de 2 heures par mois sur votre fichier Excel de trésorerie',
        'Vous avez déjà eu une mauvaise surprise de trésorerie malgré votre fichier',
        'Vous devez présenter des rapports réguliers à un CA ou des partenaires',
        'Vous voulez simuler des scénarios sans craindre de casser le fichier',
      ],
    },
    {
      type: 'solution',
      title: 'Trezoone : le passage naturel depuis Excel',
      content: 'Trezoone n\'est pas un outil complexe. C\'est Excel amélioré — avec une connexion bancaire, des alertes et des scénarios intégrés.',
      items: [
        'Import de vos données existantes depuis Excel pour démarrer',
        'Interface aussi simple que Excel — sans les risques',
        'Mise à jour automatique depuis votre banque',
        'Alertes et prévisions automatisées',
        'À partir de 59 €/mois — rentabilisé dès le premier découvert évité',
      ],
    },
    {
      type: 'cluster',
      title: 'Outils et méthodes de trésorerie',
      links: [
        { label: 'Logiciel de trésorerie', href: '/logiciel-tresorerie' },
        { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
        { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
        { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
        { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
        { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
        { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Testez Trezoone — gardez Excel si vous préférez',
      content: 'Essai gratuit 14 jours. Sans carte, sans engagement. Si Excel vous convient mieux, aucun problème.',
    },
  ],
  relatedLinks: [
    { label: 'Logiciel de trésorerie', href: '/logiciel-tresorerie' },
    { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
    { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
    { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
    { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
    { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
    { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
    { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function ExcelVsLogicielTresoreriePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
